import React from "react";
import classNames from "classnames";
import {useController} from "react-hook-form";
import ValidationFeedback from "../../ValidationFeedback";
import {CInputCheckbox, CLabel, CFormGroup} from "@coreui/react";

const ARInputCheckbox = ({control, name, id, labelText, className, labelClassName, ...props}) => {
  const {field, fieldState} = useController({
    name,
    control,
    defaultValue: false
  });

  const {ref, value, ...inputProps} = field;
  const {error} = fieldState;

  return (
    <CFormGroup className={classNames(className)}>
      <CInputCheckbox
        id={id}
        innerRef={ref}
        checked={value}
        {...inputProps}
        {...props}
      />
      <CLabel htmlFor={id || ""} className={classNames(labelClassName)}>
        {labelText}
      </CLabel>
      <ValidationFeedback error={error}/>
    </CFormGroup>
  );
};

export default ARInputCheckbox;